import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import Antd from 'ant-design-vue'
import AdminFilters from '@/components/AdminFilters.vue'
import 'ant-design-vue/dist/antd.css'
import '@/styles/theme.css'
import '@/styles/admin-workspace.css'
import '@/styles/admin-mobile.css'
import '@/styles/admin-dark.css'
import './permission' // 引入路由守卫
import { adminLocaleState, setAdminLocale, t, translateRouteTitle } from '@/i18n'

Vue.config.productionTip = false
Vue.use(Antd)
Vue.component('AdminFilters', AdminFilters)

Vue.prototype.$t = t
Vue.prototype.$setAdminLocale = setAdminLocale
Vue.prototype.$translateRouteTitle = translateRouteTitle
Vue.mixin({
    computed: {
        $adminLocale() {
            return adminLocaleState.locale
        },
        $adminLocalePreference() {
            return adminLocaleState.preference
        }
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
